import { Label, Text } from '@gravity-ui/uikit';
import type { ManagerAuditEntry } from '@odonix/contracts';
import { moment } from '../../ui/format.js';
import { RouterLink } from '../../ui/router-link.js';
import { MANAGER_ACTION_LABEL, MANAGER_ACTION_THEME, describeEntry } from './labels.js';

/**
 * Лента журнала менеджеров: кто, что, с какой клиникой, подробность и время.
 * Одна и та же в общем журнале и во вкладке «Действия» карточки менеджера.
 */
export function AuditFeed({ entries, showManager = true }: { entries: readonly ManagerAuditEntry[]; showManager?: boolean }) {
  return (
    <ul className="flex flex-col divide-y divide-[var(--g-color-line-generic)]">
      {entries.map((entry) => {
        const detail = describeEntry(entry);
        return (
          <li key={entry.id} className="flex flex-col gap-1 px-5 py-3 sm:flex-row sm:items-start sm:gap-4">
            <Text color="secondary" className="tabular w-40 shrink-0 pt-0.5" whiteSpace="nowrap">
              {moment(entry.occurredAt)}
            </Text>
            <div className="flex min-w-0 flex-1 flex-col gap-1">
              <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                {showManager ? (
                  <RouterLink to={`/managers/${entry.managerId}`}>{entry.managerName ?? entry.managerEmail}</RouterLink>
                ) : null}
                <Label theme={MANAGER_ACTION_THEME[entry.action]} size="xs">
                  {MANAGER_ACTION_LABEL[entry.action]}
                </Label>
                {entry.targetTenantId === null ? null : (
                  <RouterLink to={`/tenants/${entry.targetTenantId}`} view="secondary">
                    {entry.targetTenantName ?? 'клиника'}
                  </RouterLink>
                )}
              </div>
              {detail === null ? null : (
                <Text color="secondary" className="break-words">
                  {detail}
                </Text>
              )}
            </div>
            {entry.ip === null ? null : (
              <Text variant="caption-2" color="hint" className="tabular shrink-0 sm:pt-1">
                {entry.ip}
              </Text>
            )}
          </li>
        );
      })}
    </ul>
  );
}
